import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeSearch.css';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import {
  HomeWork,
  DirectionsCar,
  TwoWheeler,
  Build,
  Computer,
  CleanHands,
  Star,
  LocalOffer,
  Apartment,
  House,
  CarRental,
  SupportAgent,
  Emergency,
  Construction,
  Campaign,
  HouseboatOutlined,
  Brush,
  AutoAwesome,
  Edit,
  Gavel,
  TwoWheelerOutlined,
  BuildCircleOutlined,
  EmojiEmotions,
  ConstructionRounded,
  ComputerRounded,
  CleanHandsOutlined,
  StarBorderPurple500Outlined,
  LocalOfferOutlined,
  ApartmentOutlined,
  CarRentalOutlined,
  SupportAgentOutlined,
  EmergencyOutlined,
  ConstructionOutlined,
  LocalShippingOutlined,
  FactoryOutlined,
  DirectionsCarFilledOutlined,
  FormatListBulletedOutlined,
  NatureOutlined,
  LocalFlorist,
  FlashOnOutlined,
  AccountBalanceWalletRounded,
  FitnessCenter,
  HomeRepairService,
  SettingsApplications,
  InterestsSharp,
  HealthAndSafety,
  Watch,
  Kitchen,
  KitchenRounded,
  AttachMoneyOutlined,
  DirectionsCarFilled,
  EventAvailable,
  LocalDining,
  GavelSharp,
  Pets,
  WifiCalling3,
  TheaterComedySharp,
  PersonAddAltSharp,
  SportsKabaddiOutlined,
  ArchiveOutlined,
  Groups,
  RealEstateAgent,
  TravelExplore,
  PestControl,
  Print,
  RollerShadesClosedOutlined,
  AttachMoneySharp,
  PhotoCamera,
  Inventory,
  ShieldMoonOutlined,
  MedicationLiquidOutlined,
  ReceiptOutlined,
  BuildCircle,
} from '@mui/icons-material';

function HomeSearch() {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [itemsPerSlide, setItemsPerSlide] = useState(8);

useEffect(() => {
  const updateItemsPerSlide = () => {
    if (window.innerWidth < 480) {
      setItemsPerSlide(2);
    } else if (window.innerWidth < 768) {
      setItemsPerSlide(3);
    } else if (window.innerWidth < 1024) {
      setItemsPerSlide(5);
    } else {
      setItemsPerSlide(8);
    }
  };

  updateItemsPerSlide();
  window.addEventListener('resize', updateItemsPerSlide);
  return () => window.removeEventListener('resize', updateItemsPerSlide);
}, []);


  // Format category name for URL
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '');

  useEffect(() => {
    fetch('https://anyworq.com/api/services')
      .then(res => res.json())
      .then(data => {
        const categoriesObj = data[0]?.categories?.[0] || {}; // The real object with keys
const iconMap = {
  '<House />' :<HouseboatOutlined />,
  '<HomeWork />': <HomeWork />,
  '<DirectionsCar />': <DirectionsCar />,
  '<Campaign />':<Campaign />,
  '<Brush />' :<Brush />,
  '<Sparkles />':<AutoAwesome />,
   '<PencilLine />':<Edit />,
  '<MdDigitalMarketing />':<Campaign />,
  '<Gavel />':<Gavel />,
  '<TwoWheeler />': <TwoWheelerOutlined />,
  '<Build />': <BuildCircleOutlined />,
  '<EmojiEmotions />':<EmojiEmotions />, 
  '<ConstructionRounded />':<ConstructionRounded />,
  '<Computer />': <ComputerRounded />,
  '<CleanHandsOutlined />' : <CleanHandsOutlined />,
'<StarBorderOutlined />': <StarBorderPurple500Outlined />,
'<LocalOfferOutlined />' :<LocalOfferOutlined />,
'<ApartmentOutlined />' :<ApartmentOutlined />,
'<HouseOutlined />' :<HouseboatOutlined />,
'<CarRentalOutlined />':<CarRentalOutlined />,
'<SupportAgentOutlined />':<SupportAgentOutlined />,
  '<Emergency />': <EmergencyOutlined />,
  '<Construction />': <ConstructionOutlined />,
  '<LocalShipping />' :<LocalShippingOutlined />,
  '<Factory />' :<FactoryOutlined />,
  '<Receipt />':<ReceiptOutlined />,
  '<FaShippingFast />':<DirectionsCarFilledOutlined />,
  '<FaBolt />':<FormatListBulletedOutlined />,
  '<MdGrass />':<NatureOutlined />,
  '<MdLocalFlorist />':<LocalFlorist />,
  '<FlashOnIcon />':<FlashOnOutlined/>,
   '<AccountBalanceWallet />':<AccountBalanceWalletRounded />,
   '<MdFitnessCenter />': <FitnessCenter />,
   '<MdHomeRepairService />':<HomeRepairService />,
   '<MdSettingsApplications />':<SettingsApplications />,
   '<MdOutlineChair />':<InterestsSharp/>,
   '<GiFactory />':<FactoryOutlined />,
   '<MdHealthAndSafety />':<HealthAndSafety />,
   '<GiWatch />':<Watch />,
   '<GiKitchenKnives />':<Kitchen />,
   '<MdKitchen />':<KitchenRounded />,
   '<MdAttachMoney />':<AttachMoneyOutlined />,
   '<DirectionsCarFilled />':<DirectionsCarFilled />,
   '<MdBuildCircle />':<BuildCircle />,
   '<MdGavel />':<Gavel />,
   '<MdEvent />':<EventAvailable />,
   '<LocalDining />':<LocalDining />,
   '<MdGavel />':<GavelSharp />,
   '<MdSupportAgent />':<SupportAgent />,
   '<MdPets />':<Pets />,
   '<MdWifiCalling3 />':<WifiCalling3 />,
   '<FaChalkboardTeacher />':<TheaterComedySharp/>,
   '<MdPersonSearch />':<PersonAddAltSharp />,
   '<MdSportsKabaddi />':<SportsKabaddiOutlined />,
   '<GiArchiveRegister />':<ArchiveOutlined/>,
   '<MdGroups />' :<Groups />,
   '<MdRealEstateAgent />':<RealEstateAgent />,
   '<FaPlaneDeparture />':<TravelExplore />,
   '<GiBugNet />':<PestControl />,
   '<FaPrint />':<Print />,
   '<TbRollerPaint />':<RollerShadesClosedOutlined />,
   '<MdOutlineReceiptLong />':<AttachMoneySharp />,
   '<MdPhotoCamera />':<PhotoCamera />,
   '<BiPackage />' :<Inventory />,
   '<RiShieldUserLine />':<ShieldMoonOutlined />,
   '<MdLocalHospital />' :<MedicationLiquidOutlined />
};

        // Flatten all top-level categories
const parsedCategories = Object.keys(categoriesObj).map(name => ({
  name,
  ...categoriesObj[name],
  services: categoriesObj[name].services || [],
  icon: iconMap[categoriesObj[name].icon] || <LocalOffer />
}));

        setCategories(parsedCategories);
      })
      .catch(err => console.error('Failed to fetch services:', err));
  }, []);

  // Extract all suggestions
  useEffect(() => {
    const allSuggestions = categories.flatMap(cat => {
      const mainCat = {
        name: cat.name,
        type: 'main-category',
        icon: cat.icon,
        color: cat.color
      };

      const subCategories = cat.services.flatMap(service =>
        service.subServices.map(sub => ({
          name: sub.name,
          type: 'sub-category',
          parentCategory: cat.name,
          parentService: service.name
        }))
      );

      return [mainCat, ...subCategories];
    });

    setSuggestions(allSuggestions);
  }, [categories]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (input.trim()) {
      navigate(`/dealers?search=${encodeURIComponent(input)}`);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion.name);
    setShowSuggestions(false);

    if (suggestion.type === 'main-category') {
      const formatted = formatCategory(suggestion.name);
      navigate(`/categories/${formatted}`);
    } else {
      navigate(`/dealers?category=${encodeURIComponent(suggestion.parentCategory)}&service=${encodeURIComponent(suggestion.parentService)}&subservice=${encodeURIComponent(suggestion.name)}`);
    }
  };

  const filteredSuggestions = input
  
    ? suggestions.filter(s => s.name.toLowerCase().includes(input.toLowerCase()))
    : suggestions.slice(0, 5);
    const totalSlides = Math.ceil(categories.length / itemsPerSlide);
 // since you show 8 per slide

  const nextSlide = () => {
  setCurrentSlide(prev => (prev < totalSlides - 1 ? prev + 1 : prev));
};

const prevSlide = () => {
  setCurrentSlide(prev => (prev > 0 ? prev - 1 : prev));
};

  const visibleCategories = categories.slice(
  currentSlide * itemsPerSlide,
  (currentSlide + 1) * itemsPerSlide
);


  const GradientWrapper = ({ children }) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <linearGradient id="iconGradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#4B698E" />
        <stop offset="100%" stopColor="#03BAA5" />
      </linearGradient>
    </defs>
    <g fill="url(#iconGradient)" className='gradient-icon'>
      {children}
    </g>
  </svg>
);

  return (
    <div className="home-search-container">
      <div className="search">
        <div className="search__logo">
          <img src="/logo.png" alt="Enyword" />
        </div>
        <form className="search__form" onSubmit={handleSearch}>
          <div className="search__input-container">
            <div className="search__input">
              <input
                type="text"
                placeholder="Service Categories"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              />
              <button type="submit">Search</button>
            </div>

            {showSuggestions && filteredSuggestions.length > 0 && (
              <div className="suggestions-dropdown">
                {filteredSuggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion.type === 'main-category' && (
                      <span
                        className="suggestion-icon"
                        style={{ color: suggestion.color }}
                      >
                        {suggestion.icon}
                      </span>
                    )}
                    <span className="suggestion-text">
                      {suggestion.name}
                      {suggestion.type === 'sub-category' && (
                        <span className="suggestion-category">
                          {suggestion.parentCategory} → {suggestion.parentService}
                        </span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </form>
      </div>

      <div className="popular-categories">
        <h2>Popular Categories</h2>
        <div className="categories-slider-container">
          <div className={`categories-slider ${window.innerWidth < 768 ? 'scrollable' : ''}`}>
            {visibleCategories.map(category => (
              <div
                key={category.name}
                className="category-card"
                onClick={() => {
                  const formatted = formatCategory(category.name);
                  navigate(`/categories/${formatted}`);
                }}
                style={{ backgroundColor: '#fff' + '20' }}
              >
                <span className="category-icon" >
<GradientWrapper>{category.icon}</GradientWrapper> 
               </span>
                <span className="category-name">{category.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="slider-dots">
          <div className="arrow">
            <button className="slider-arrow left" onClick={prevSlide} disabled={currentSlide === 0}>
              <FiChevronLeft />
            </button>
            <button className="slider-arrow right" onClick={nextSlide} disabled={currentSlide === totalSlides - 1}>
              <FiChevronRight />
            </button>
          </div>
        </div> */}


        {window.innerWidth >= 768 && (
  <div className="slider-dots">
    <div className="arrow">
      <button className="slider-arrow left" onClick={prevSlide} disabled={currentSlide === 0}>
        <FiChevronLeft />
      </button>
      <button className="slider-arrow right" onClick={nextSlide} disabled={currentSlide === totalSlides - 1}>
        <FiChevronRight />
      </button>
    </div>
  </div>
)}

      </div>
    </div>
  );
}

export default HomeSearch;
